// Helpers to update the fixed-length city/base tuples while preserving their
// tuple types. `Array.prototype.map` widens a tuple to an array, so we re-assert
// the tuple type — safe because map preserves length.

import type { Cities, Bases, City, Base } from './types';

export const mapCities = (cities: Cities, f: (c: City) => City): Cities =>
  cities.map(f) as unknown as Cities;

export const mapBases = (bases: Bases, f: (b: Base) => Base): Bases =>
  bases.map(f) as unknown as Bases;
